module.exports = __webpack_public_path__ + "jab/media/data-recycle.c843972a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-recycle.svg
// module id = 198
// module chunks = 0